export default "__VITE_ASSET__DBC696S8__"